function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { RcScheduleProvider, useCreateSchedule } from '../../hooks/schedule';
import { SchedulePanel } from './components/SchedulePanel';
export var Schedule = memo(function (props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 988 : _props$width,
      style = props.style,
      className = props.className,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? 1 : _props$divider,
      interrupted = props.interrupted,
      datasource = props.datasource,
      value = props.value,
      isTimeDisabled = props.isTimeDisabled,
      onValueChange = props.onValueChange,
      title = props.title,
      renderTooltip = props.renderTooltip,
      inverseSelect = props.inverseSelect,
      onDisplayInfoChange = props.onDisplayInfoChange,
      renderDisplayInfo = props.renderDisplayInfo,
      renderEmpty = props.renderEmpty,
      disabled = props.disabled,
      extra = _objectWithoutProperties(props, ["width", "style", "className", "divider", "interrupted", "datasource", "value", "isTimeDisabled", "onValueChange", "title", "renderTooltip", "inverseSelect", "onDisplayInfoChange", "renderDisplayInfo", "renderEmpty", "disabled"]);

  var _useCreateSchedule = useCreateSchedule({
    divider: divider,
    interrupted: interrupted,
    inverseSelect: inverseSelect,
    datasource: datasource,
    value: value,
    isTimeDisabled: isTimeDisabled,
    onValueChange: onValueChange,
    disabled: disabled
  }),
      schedule = _useCreateSchedule.schedule;

  var cls = classnames(usePrefixCls('schedule'), className);
  var num = divider * 24;
  var colWidth = Math.floor((width - 102) / num);
  var acturalWidth = colWidth * num + 102;
  return React.createElement(RcScheduleProvider, {
    schedule: schedule
  }, React.createElement("div", Object.assign({}, extra, {
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: "".concat(acturalWidth, "px")
    }),
    className: cls
  }), React.createElement(SchedulePanel, {
    disabled: disabled,
    title: title,
    renderTooltip: renderTooltip,
    colWidth: colWidth,
    onDisplayInfoChange: onDisplayInfoChange,
    renderDisplayInfo: renderDisplayInfo,
    renderEmpty: renderEmpty
  })));
});